/** Client-side loan amortization (runs entirely in browser). */

export function amortization({ principal, annualRate, years }) {
  const p = Number(principal) || 0;
  const r = (Number(annualRate) || 0) / 100 / 12;
  const n = Math.max(1, (Number(years) || 0) * 12);
  if (p <= 0) return { monthly: 0, totalPaid: 0, totalInterest: 0, payoffYear: new Date().getFullYear(), requiredIncome: 0 };
  const monthly = r === 0 ? p / n : (p * r) / (1 - Math.pow(1 + r, -n));
  const totalPaid = monthly * n;
  const totalInterest = totalPaid - p;
  const now = new Date();
  const payoffYear = now.getFullYear() + Math.ceil(n / 12);
  // Rule of thumb: monthly loan payment should be ≤ 10% of gross monthly income
  const requiredIncome = Math.round(monthly * 12 / 0.10);
  return {
    monthly: Math.round(monthly),
    totalPaid: Math.round(totalPaid),
    totalInterest: Math.round(totalInterest),
    payoffYear,
    requiredIncome,
  };
}

export const LOAN_TYPES = [
  { id: "subsidized", name: "Direct Subsidized", rate: 6.53, note: "Need-based. Government pays interest while in school. Undergrads only." },
  { id: "unsubsidized", name: "Direct Unsubsidized", rate: 6.53, note: "Available to all. Interest accrues from day one." },
  { id: "plus_parent", name: "Parent PLUS", rate: 9.08, note: "For parents of dependent undergrads. Credit check required. 4.23% origination fee." },
  { id: "plus_grad", name: "Grad PLUS", rate: 9.08, note: "For graduate students. Credit check required." },
  { id: "private", name: "Private (typical)", rate: 11.0, note: "Rates vary widely. Requires credit score/co-signer. No federal protections." },
];
